import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_CZ: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astrologie',
  components_header_media_multi_content_2: 'Rozjímání',
  components_header_media_multi_content_3: 'Láska',
  components_header_text1: 'Průvodci',
  components_header_text2: 'Blog',
  hero_text: 'Najděte jasnost, rovnováhu a spojení.',
  hero_button_text: 'Začněte svou cestu',
  components_ressources_subheader_text: 'Tipy a inspirace',
  components_ressources_span_text: 'Spojuje osobní astrologické vhledy, uklidňující meditační praktiky a promyšlené vedení v oblasti lásky, které podporují sebepoznání, emocionální rovnováhu a hlubší spojení.',
  components_ressources_card_1_title: 'Tipy pro meditaci',
  components_ressources_card_1_text: 'Rychlý průvodce pro lepší klid, dýchání a soustředění.',
  components_ressources_card_2_title: 'Vedení lásky',
  components_ressources_card_2_text: 'Jednoduché tipy pro budování silnějšího vztahu a emocionální rovnováhy.',
  components_ressources_link: 'Objevte více',
  components_notes_and_google_title_1: 'Najděte jasnost',
  components_notes_and_google_title_2: 'Vnitřní klid',
  components_notes_and_google_title_3: 'Spojení srdce',
  media_content_section_multi_1_subheader_text: 'Náš podcast',
  media_content_section_multi_2_subheader_text: 'Naše meditace',
  media_content_section_multi_3_subheader_text: 'Skutečný rozhovor o kosmické romanci',
  page_media_content_menu_antistress: 'Antistresový',
  page_media_content_menu_mindfulness: 'Všímavost',
  page_media_content_menu_energyboost: 'Zvýšení energie',
  page_media_content_menu_mantra: 'Mantra',
  page_media_content_menu_foundations: 'Nadace',
  page_media_content_menu_spirituality: 'Duchovno',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psychologie',
  page_media_content_menu_trends: 'Trendy',
  page_media_content_menu_compatibility: 'Kompatibilita',
  page_media_content_menu_love: 'Láska',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Články a postřehy',
  text2_section_button_more: 'Načíst více',
  components_text1_section_title: 'PRŮVODCI',
  components_text1_subheader_text: 'Kosmické znalosti pro každodenní sladění',
  components_text1_span_text: 'Sladte se s rytmy vesmíru: prozkoumejte kurátorskou sbírku hloubkových astrologických a meditativních průvodců, které jsou navrženy tak, aby probudily vnitřní jasnost, prohloubily sebeuvědomění a podpořily vaši cestu duchovního, nebeského růstu.',
  components_text1_card_1_title: 'Otevřeno tichu',
  components_text1_card_1_text: 'Začněte svou cestu se základními meditačními a astrologickými průvodci – ideálními pro hledače, které přitahuje vnitřní klid, kosmické vzorce a osobní vhled.',
  components_text1_card_3_title: 'Propojení mysli a těla',
  components_text1_card_3_text: 'Odhalte hlubší vrstvy svého vnitřního světa. Tito průvodci se posouvají pod povrch a odhalují význam, emoce a vzorce vědomí, které utvářejí vaši zkušenost.',
  components_text1_card_2_title: 'Reflektovat a integrovat',
  components_text1_card_2_text: 'Od emočních bloků až po planetární cykly – tito průvodci nabízejí nástroje pro reflexi, léčení a transformaci prostřednictvím vědomých rituálů a astrologické moudrosti.',
  components_text1_link: 'Zobrazit všechny průvodce',
  components_footer_text: 'Najděte jasnost, vyrovnejte svou mysl a spojte se se smyslem – vaše místo pro astrologii, meditaci a lásku.',
};